import { FormBuilder, FormGroup } from '@angular/forms';
import { MyElEntiConv, MyVerbale } from '../../../../../models/interfaces/revisione.interface';
import { rebuildFormArray } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const buildEntiConvFormArray = (fb: FormBuilder, myVerbale: MyVerbale, form: FormGroup) => {
    const elEntiConv = myVerbale?.my_SezioneI__Rilevazione?.my_SchedaCoopSociali?.my_EntiConv?.my_ElEntiConv;
    rebuildFormArray(fb, elEntiConv, form, `${formPaths.schedaCoopSociali}.my_EntiConv.my_ElEntiConv`, buildEnteConvGroup);
};

export const buildEnteConvGroup = (fb: FormBuilder, item?: MyElEntiConv): FormGroup => {
    return fb.group({
        my_ConvEnte: item?.my_ConvEnte,
        my_ConvOggetto: item?.my_ConvOggetto,
        my_ImportoConvenzione: item?.my_ImportoConvenzione,
        my_id_convenzione: item?.my_id_convenzione,
    });
};
